export default function OlmComparisonChart() {
    const olmComparisonChart = [
        {
            feature: 'Customization and Personalization ',
            olm: 'Extensive',
            other: 'Limited',
        },
        {
            feature: 'Innovative Strategies',
            olm: 'Cutting-edge',
            other: 'Standard',
        },
        {
            feature: 'Experience and Expertise',
            olm: 'Investor-Founded',
            other: 'Varied',
        },
        {
            feature: 'Range of Services',
            olm: 'Comprehensive',
            other: 'Basic to Moderate',
        },
        {
            feature: 'Continuous Improvement',
            olm: 'Always Adapting',
            other: 'Rarely',
        },
        { feature: 'Customer Support', olm: 'Personalized', other: 'Generic' },
        {
            feature: 'Response Rate Efficiency',
            olm: 'Higher',
            other: 'Standard',
        },
        { feature: 'Turnaround time', olm: '2 days', other: '1+ weeks' },
    ]

    return (
        <div className="bg-light-yellow-gradient md:py-10 py-4 rounded-4xl md:rounded-8xl">
            {/* Outer: no horizontal overflow here */}
            <div className="xl:px-0 m-auto my-10 max-w-full w-11/12 md:w-[1000px] md:px-6 md:space-y-8 space-y-2 text-center">
                <p className="md:text-[22px] text-xl font-semibold">
                    Comparison Chart:
                </p>

                <h3 className="md:text-[55px] space-x-1 md:leading-[4rem] text-3xl font-bold">
                    <span className="olm-gradient-text">
                        Open Letter Marketing
                    </span>
                    <br className="block md:hidden" />
                    <span>vs.</span> <br className="hidden md:block" />
                    Standard Direct <br className="block md:hidden" /> Mail
                    Services
                </h3>

                {/* Single scroll container */}
                <div className="md:text-[18px] text-base leading-[30px] text-left overflow-x-auto overflow-y-hidden">
                    <div className="flex min-w-[1000px] mb-8">
                        <div className="w-1/3 border-r border-olm font-semibold shrink-0">
                            <p className="px-3 py-5 border-b border-olm">
                                Features
                            </p>
                            {olmComparisonChart.map((chart, index) => (
                                <p
                                    key={index}
                                    className="px-3 py-5 border-b border-olm">
                                    {chart.feature}
                                </p>
                            ))}
                        </div>

                        <div className="w-1/3 border-r border-olm bg-gradient-to-b from-transparent via-[#fdedce] to-transparent text-[#3F454F] shrink-0">
                            <p className="pl-10 py-5 olm-gradient-text font-bold border-b border-olm">
                                Open Letter Marketing
                            </p>
                            {olmComparisonChart.map((chart, index) => (
                                <p
                                    key={index}
                                    className="pl-10 py-5 border-b border-olm space-x-1">
                                    <img
                                        className="inline-block align-middle mr-1"
                                        src="/assets/switch-to-us/check-icon.svg"
                                        alt=""
                                    />
                                    <span>{chart.olm}</span>
                                </p>
                            ))}
                        </div>

                        <div className="w-1/3 text-[#3F454F] shrink-0">
                            <p className="pl-8 py-5 border-b border-olm">
                                Other Direct Mail Companies
                            </p>
                            {olmComparisonChart.map((chart, index) => (
                                <p
                                    key={index}
                                    className="pl-10 py-5 border-b border-olm">
                                    {chart.other}
                                </p>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
